import { Box, Link, Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getHmrcAvailability } from 'redux/reducers/settings/selectors';
import { WarningAlert } from 'ui/WarningAlert';

export const Step2HMRC: FC = () => {
	const checkAvailability = useSelector(getHmrcAvailability);
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				mt: '20px',
				gap: 2,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					// width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						Before proceeding with integration to the EAS solution ensure that you have connected
						VAT service to your HMRC VAT account, see instructions here: &nbsp;
						<br />
						<Link
							href="https://help.easproject.com/hc/en-gb/articles/5026009048223-Connecting-VAT-services-to-your-HMRC-account"
							target="_blank"
							rel="noreferrer"
							sx={{
								color: '#016193',
								fontSize: '1rem',
								fontWeight: 'bold',
								textDecoration: 'none',
								'&:hover': {
									textDecoration: 'underline',
								},
							}}
						>
							Connecting VAT services to your HMRC account
						</Link>
						.
						<br />
						Do not proceed further until you successfully connected VAT service to your HMRC
						account.
					</Typography>
				</Box>
			</Box>
			{!checkAvailability?.isAvailable && (
				<WarningAlert>
					You are attempting to connect your EAS solution to HMRC. However, our system does not
					currently contain your United Kingdom VAT registration information.
					<br />
					Please send a copy of your VAT registration certificate to your support manager at{' '}
					<Link
						href="mailto:support@easproject.com"
						target="_blank"
						rel="noreferrer"
						color="primary"
						sx={{
							fontWeight: 'bold',
							textDecoration: 'none',
							'&:hover': { textDecoration: 'underline' },
						}}
					>
						support@easproject.com
					</Link>
					. Once we receive the document, we will process your request as soon as possible.
				</WarningAlert>
			)}
		</Box>
	);
};
